import { LAYOUT_COMPONENT_TYPE, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const navigationHeaderDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.navigation,
  componentType: LAYOUT_COMPONENT_TYPE.navigationHeader,
  displayOrder: 0,
  content: {
    siteTitle: loc3('Trattoria Aurora', 'Trattoria Aurora', 'Trattoria Aurora'),
    navLink1: loc3('Speisekarte', 'Menu', 'Thực đơn'),
    navLink2: loc3('Über uns', 'About', 'Giới thiệu'),
    navLink3: loc3('Kontakt', 'Contact', 'Liên hệ'),
    ctaLabel: loc3('Reservieren', 'Reserve', 'Đặt bàn'),
  },
  // Fine-Dining / classic Look: typography-only brand (studio bootstrap seeds no logo).
  // Design Lab injects platform marks when Look prefers a logo.
  media: {},
};
